import { render, staticRenderFns } from "./box_1.vue?vue&type=template&id=3f1ccf18&scoped=true"
import script from "./box_1.vue?vue&type=script&lang=js"
export * from "./box_1.vue?vue&type=script&lang=js"
import style0 from "./box_1.vue?vue&type=style&index=0&id=3f1ccf18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ccf18",
  null
  
)

export default component.exports